import React, { useContext, useEffect, useState } from 'react'
import { BookingContext } from './NewBooking'
import API from '../../../services/API'
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material'
import BigModal from '../../../components/Modals/BigModal'
import AddNewWardDepartment from '../Organisations/AddNewWardDepartment'
import { AddCircle } from '@mui/icons-material'

const getId = (value) => (typeof value === 'string' ? value : value?._id)

const OrganisationWardSelector = ({ value, onChange }) => {
  const [wardOptions, setWardOptions] = useState([])
  const [loadingOptions, setLoadingOptions] = useState(true)
  const [openAddNewWard, setOpenAddNewWard] = useState(false)
  const { formData, handleChange, setOrgHasWards } = useContext(BookingContext)

  const organisationId = formData?.organisation?._id

  useEffect(() => {
    if (!organisationId) {
      setWardOptions([])
      setLoadingOptions(false)
      setOrgHasWards?.(true)
      return
    }
    setLoadingOptions(true)
    API.get(`/pts/warddepartmentoptions/${organisationId}`)
      .then((res) => {
        if (res.status === 200) {
          setWardOptions(res.data)
          setOrgHasWards?.((res.data || []).length > 0)
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoadingOptions(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationId])

  return (
    <>
      <Autocomplete
        options={wardOptions}
        loading={loadingOptions}
        value={value ?? null}
        disabled={!organisationId}
        getOptionKey={(option) => option?._id}
        getOptionLabel={(option) =>
          `${option?.name || ''} ${option?.internalLocation ? `(${option.internalLocation})` : ''}`
        }
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        onChange={(event, newValue) => {
          onChange(newValue || null)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Ward / Department"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                  {!value && organisationId && (
                    <InputAdornment position="end">
                      <Tooltip title="Add a new Ward or Department">
                        <IconButton onClick={() => setOpenAddNewWard(true)}>
                          <AddCircle color="anGreen" />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  )}
                  {/* TODO: Allow editing of Organisation from the Booking Screen. */}
                  {/* {selectedOrganisation && (
                    <InputAdornment position="end">
                      <Tooltip
                        title={`Edit ${selectedOrganisation?.orgName ?? ''}`}
                      >
                        <IconButton onClick={() => {}}>
                          <Edit color="contrast" />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  )} */}
                </>
              ),
            }}
            helperText={
              !organisationId
                ? 'Select an organisation first'
                : value?.internalLocation
                  ? value.internalLocation
                  : ''
            }
          />
        )}
      />
      <AddNewWardDepartment
        open={openAddNewWard}
        onClose={() => setOpenAddNewWard(false)}
        organisation={{
          _id: organisationId,
          orgName: formData?.organisation?.orgName,
        }}
        afterAdd={(newWard) => {
          if (!newWard?._id) return
          setWardOptions((prev) =>
            prev.some((option) => option?._id === newWard._id)
              ? prev
              : [...prev, newWard],
          )
          handleChange('wardDepartment', newWard)
        }}
      />
    </>
  )
}
export default OrganisationWardSelector
